// eslint-disable-next-line
import React from 'react';
import { Modal, IModalProps } from '@cb/apricot-react';

export default function ModalWrapper(props: IModalProps) {
  return <Modal headerId='modal-title-heading' {...props} />;
}
